<template>
    <div class="order">
        <div class="search m-b-20">
            <div class="search-box flex-row">
                <img class="searchImg" :src="search" alt="" >
                <input class="searchVal" placeholder="请输入客户姓名/电话/订单号/地址" v-model="value" type="text" @input="seachList">
            </div>
        </div>
        <ul class="orderList" >
            <li class="item m-b-20" v-for="(item, index) in orderList" :key="index" >
                <div class="title brder-b flex-row">
                    <div class="orderNumber">订单号：{{item.orderNumber}}
                        <div class="packageType">
                            <span v-if="item.packageType === 0">标准订单</span>
                            <span style="background: #FF8C00;" v-if="item.packageType === 1">A套餐</span>
                            <span style="background: #28A745;" v-if="item.packageType === 2">B套餐</span>
                        </div>
                    </div>
                    <div class="orderStats">
                        <span v-if="!item.isCollect" @click="viewContract(item)">补贴套餐明细</span>
                    </div>
                </div>
                <div class="product m-t-25">付款金额：19800</div>
                <div class="product m-t-25">客户姓名：{{item.customerName}}</div>
                <div class="product m-t-25">客户电话：{{item.customerPhone}}</div>
                <div class="product border-bottom p-b-20 m-t-20 flex-row flex-main">
                    <div>客户地址：</div>
                    <div>{{item.address}}</div>
                </div>
                
                <div class="product flex-row m-t-20">
                    <p>品牌：{{item.brandName}}</p>
                    <p>品类：{{item.categoryName}}</p>
                </div>
                <div class="product m-t-25">所属门店：{{item.storeName}} </div>
                <div class="item-footer-btn">
                    <div class="pay-btn"  v-if="!item.storeExpenditureId" @click="handelPay(item)">付款</div>
                    <div class="pay-qrcode"  @click="handelShowCode(item)" v-if="item.storeExpenditureId">支付二维码</div>
                </div>
            </li>
        </ul>
        <van-popup 
            v-model="showPopup" 
            class="img"
            round 
            closeable
            position="center"
            :style="{ padding: '30px', textAlign: 'center' }"
            >
            <div class="qrcode-box" >
                <img 
                :src="imgUrl" 
                alt="QR Code" 
                class="qrcode-img" 
                />
                
                <p class="qrcode-tip">请长按识别二维码支付或保存图片</p>
            </div>
        </van-popup>
        <van-popup 
            v-model="showFormPopup" 
            round 
            
            position="center"
            :style="{ padding: '30px', textAlign: 'center' }"
            >
                <div class="form-main">
                    <div class="form-text">
                        <div class="from-tit">请输入付款金额</div>
                    </div>
                    <input type="text" v-model="formData.paymentAmount" placeholder="请输入">
                    <div class="form-btn">
                        <span @click="handelFormClose">取消</span>
                        <span @click="handelFormSubmit">确认</span>
                    </div>
                </div>
            </van-popup>
        <van-popup 
            v-model="showPopup2" 
            class="img"
            round 
            closeable
            position="center"
            :style="{ padding: '30px', textAlign: 'center' }"
            >
            <div class="qrcode-box" >
                <img 
                :src="tcimgUrl" 
                alt="QR Code" 
                class="qrcode-img" 
                />
                
            </div>
        </van-popup>
    </div>
</template>
<script>
import search from '@/assets/img/search.png';
import product from '@/assets/img/product.jpg';
import tel from '@/assets/img/tel.png';
import { listOrderByPackage, checkIsCollected, getCollectCodeAccount } from '@/api/index';
import {  Toast, Dialog, Popup, ShareSheet, } from 'vant';
import receiving from '@/assets/img/收货@3x.png';
import { addStoreExpenditure } from '@/api/index';
export default {
    data(){
        return {
            search,
            product,
            tel,
            value:'',
            orderList:[],
            allOrderList: [],
            showPopup: false,
            showPopup2: false,
            qrcodeImg: false,
            imgUrl: '',
            tcimgUrl: '',
            showShare: false,
            qrcodeText: '',
            showFormPopup: false,
            formData: {
                paymentAmount: ''
            },
            selectRow: {},
            options: [
                { name: '微信', icon: 'wechat', id: 1 },
                { name: '支付宝',id: 2, icon: 'https://fanhuayiju.oss-cn-beijing.aliyuncs.com/zfb-icon.png' },
            ],
        }
    },
    components:{
        [Toast.name] : Toast,
        [Dialog.name] : Dialog,
        [Popup.name] : Popup,
        [ShareSheet.name] : ShareSheet,
      
        
    },
    created(){
        this.$loca.getItem('routeItem', this.$route.path);
        this.getData();
    },
    methods:{
        async handelShowCode(item) {
            let urlData = await this.getCollectCodeAccountFunc(item.collectCodeAccountId)
            this.imgUrl = urlData.codeUrl
            this.showPopup = true
        },
        onSelect(item) {
            if(item.id == 2) {
                this.qrcodeImg = 'https://fanhuayiju.oss-cn-beijing.aliyuncs.com/-ds-20260612182327_376_125.png'
                this.qrcodeText = '请长按保存二维码'
            } else {
                this.qrcodeImg = 'https://fanhuayiju.oss-cn-beijing.aliyuncs.com/1c0792ed-a9af-4502-977b-95c955611535.png'
                this.qrcodeText = '请长按识别二维码支付或保存'
            }
            this.showShare = false
            this.showPopup = true
        },
        viewContract(item){
            if(item.packageType == 1) {
                this.tcimgUrl = 'https://fanhuayiju.oss-cn-beijing.aliyuncs.com/wx_20260612161421_411_152.jpg'
            } else {
                this.tcimgUrl = 'https://fanhuayiju.oss-cn-beijing.aliyuncs.com/wx_20260612161428_412_152.jpg'
            }
            this.showPopup2 = true
            
        },
        handelFormClose() {
            this.showFormPopup = false;
            this.formData.paymentAmount = '';
        },
        isNumberAndAtLeast19800(value) {
            const num = Number(value);
            return (
                Number.isFinite(num) && 
                num >= 19800 &&
                String(num) === String(value).trim() // 确保无精度丢失（关键！）
            );
        },
        handelFormSubmit() {
            if(!this.isNumberAndAtLeast19800(this.formData.paymentAmount)) {
                Toast.fail('请输入大于等于19800的金额')
                return 
            }
            const item = {
                ...this.selectRow,
                paymentAmount: this.formData.paymentAmount
            }
            this.handelFormClose();
            this.handelSubmit(item)
        },
        handelPay(item) {
            // this.showFormPopup = true;
            // this.selectRow = item
            // // return false
            Dialog.confirm({
                title: '提示',
                message: '确认进行补贴套餐付款?',
            }) .then(() => {
                this.handelSubmit(item)
            })
            .catch(() => {
                // on cancel
            });
        },
        getCollectCodeAccountFunc(collectCodeAccountId) {
            return new Promise((resolve, reject) => {
                getCollectCodeAccount({ collectCodeAccountId }).then(res=> {
                    if(res.status == 200) {
                        resolve(res.data)
                    }
                })
            })
        },
        async handelSubmit(query) {
            let data = {
                storeId: query.storeId,
                packageType: query.packageType,
                orderId: query.orderId,
                paymentAmount: 19800,
                customerName: query.customerName,
                customerPhone: query.customerPhone,
                remarks: `订单号：${ query.orderNumber } || 客户姓名：${ query.customerName } || 客户电话：${ query.customerPhone } || 合伙人不可开发票`
            }
            Toast.loading({
                message: '加载中...',
                forbidClick: true,
            });
            let urlData = await this.getCollectCodeAccountFunc(query.collectCodeAccountId)
            if(urlData) {
                data = {
                    ...data,
                    ...urlData
                }
            }
            addStoreExpenditure(data).then(res=> {
                if(res.status == 200) {
                    Toast.success({
                        message: '操作成功！',
                        forbidClick: true,
                    })
                    this.getData();
                    if(urlData.codeUrl) {
                        this.imgUrl = urlData.codeUrl
                        this.showPopup = true
                    } else {
                        Toast.fail('当前没有付款二维码，请联系销售进行支付！')
                    }
                } else {
                    Toast.fail( res.message || '操作失败！')
                    setTimeout(() => {
                         Toast.clear();
                    },1000)
                }
            }).catch(()=>{
                Toast.clear();
            })
        },
        seachList(){
             const keyword = this.value.trim().toLowerCase();
            if (!keyword){
                this.orderList = this.allOrderList
                return
            }

            // 定义需要查询的字段
            const searchFields = ['orderNumber', 'customerName', 'customerPhone', 'address'];

            let list = this.allOrderList.filter(item => {
                return searchFields.some(field => {
                return String(item[field] || '').toLowerCase().includes(keyword);
                });
            });
            this.orderList = list  
        },
        /**
         * 获取订单列表
         * @method getData
         */
        getData(){
            let data = this.$loca.getItem('phone');       
            let name = this.$loca.getItem('name');
            listOrderByPackage({customerPhone: data, limit: 999 ,orderNumber: this.value}).then(res => {
                if(res.status == 200) {
                    let isPay = res.data.rows.some(item => item.storeExpenditureId)
                    if(isPay) {
                        res.data.rows = res.data.rows.filter(item=> item.storeExpenditureId)
                    }
                    this.allOrderList = res.data.rows || []
                    this.orderList = res.data.rows || [];
                }
            }).catch(error => {
                console.log('获取合同列表 views/appointment/list.vue');
            })
        }
    }
}
</script>
<style lang="scss" scoped>
   ::v-deep .van-share-sheet__options{
       padding: 20px 100px;
       box-sizing: border-box;
        display: flex !important;
        justify-content: space-between !important;
    }
.order{
    background: $color-ed;
    .form-main{
        width: 80vw;
        .form-text{
            
            .from-tit{
                font-size: 30px;
                font-weight: bold;
            }
            color: #666;
        }
        input{
            border: solid 1px #f0f0f0;
            box-shadow: 0 0 15px #ccc;
            width: 500px;
            height: 80px;
            border-radius: 10px;
            margin-top: 40px;
            text-align: center;
        }
        .form-btn{
            padding-top: 50px;
            width: 500px;
            display: flex;
            justify-content: space-between;
            margin: 0 auto;
            span{
                width: 200px;
                height: 60px;
                line-height: 60px;
                text-align: center;
                box-shadow: 0 0 15px #ccc;
                border-radius: 10px;
                background: #f0f0f0;
                color: #666;
                &:last-child{
                    color: #fff;
                    background: cornflowerblue;
                }
            }
        }
    }
    .search{
        height: 82px;
        background: $ffff;
        .search-box{
            width:670px;
            height:60px;
            background:rgba(255,255,255,1);
            border:2px solid rgba(229,229,229,1);
            border-radius:10px;
            margin:18px 0 0 39px;
            align-items: center;
            .searchImg{
                margin-left: 17px;
                width: 24px;
                height: 24px;
            }
            .searchVal{
                margin-left: 18px;
                width: 600px;
                height: 100%;
            }
        }
    }
    .item-footer-btn{
        padding: 20px 0;
        display: flex;
        justify-content: flex-end;
        &>div{
            padding: 10px 15px;
            margin-left: 15px;
            box-shadow: 0px 0px 5px #ccc;
            color: #fff;
            border-radius: 10px;
            &.pay-btn{
                background: #07C160;
            }
            &.pay-qrcode{
                background: #FF6B00;
            }
        }
    }
    .orderList{
        background: $color-ed;
        .item{
            // height: 334px;
            background: $ffff;
            padding: 0 20px;
            padding-bottom: 10px;
            .flex-main.flex-main.flex-main{
                justify-content: flex-start;
                align-items: flex-start;
                div:nth-child(1) {
                    width: 120px;
                }
                div:nth-child(2) {
                    width: 550px;
                }
            }
            .title{
                padding: 18px 0 15px 0; 
                justify-content: space-between;
                .orderNumber{
                    font-size:28px;
                    color:rgba(51,51,51,1);
                    margin-left: 18px;
                    display: flex;
                    align-items: center;
                    .packageType{
                        margin-left: 10px;
                        color: #fff;
                        font-size: 24px;
                        
                        span{
                            font-size: 18px;
                            padding: 5px 10px;
                            border-radius: 10px;
                        }
                    }
                }
                
                .orderStats{
                    font-size:20px;
                    color:rgba(86,180,240,1);
                    margin-right: 11px;
                    span{
                        margin-left: 15px;
                    }
                }
            }
            .product{
                padding-left: 14px;
                font-size:24px;
                color: $color-102;
                justify-content: space-between;
                align-items: center;
                .time{
                    margin-right: 11px;
                    font-size:20px;
                    color:$color-187;
                }
                .numbers{
                    font-size:24px;
                    color:$color-81;
                }
                .invoice{
                    margin-right: 11px;
                    font-size:20px;
                    color:$color-153;
                }
            }
            .products{
                margin-left: 14px;
                font-size:24px;
                color: $color-102;
                align-items: center;
                position: relative;
                .time{
                    margin-right: 11px;
                    font-size:20px;
                    color:$color-187;
                }
                .numbers{
                    font-size:24px;
                    color:$color-81;
                }
                .invoice{
                    margin-right: 11px;
                    font-size:20px;
                    position: absolute;
                    left: 350px;
                }
            }
            .info{
                padding: 16px 0 10px 0;
                font-size:24px;
                color:$color-153;
                width: auto;
                align-items: center;
                justify-content: space-between;
                img{
                    width: 54px;
                    height: 54px;
                }
                .information{
                    align-items:center;
                    .names{
                        margin-bottom: 7px;
                    }
                    img{
                        width: 65px;
                        height: 65px;
                        margin: 0 25px 0 21px;
                    }
                }
            }
        }
    }
}
.qrcode-box {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.van-popup.img{
        padding: 30px 10px 10px 10px !important;
    }
    
.qrcode-img {
padding-top: 20px;
width: 700px; 
}
.qrcode-box2{
    .qrcode-img {
        padding: 50px 50px 0 50px;
        width: 500px; 
        }
}
.qrcode-tip {
  margin-top: 30px;
  font-size: 28px;
  color: #999;
}
.border-bottom{
    border-bottom:2px solid rgba(229,229,229,1);
}
.delivery{
    color:$color-162;
}
</style>

